import { useState } from 'react';

import { Wordmark } from '@shared/components/branding/Wordmark';
import { cn } from '@shared/components/ui/cn';
import { useActiveWorkspace } from '@shared/hooks/use-workspaces';

export function BrandLogo({ className }: { className?: string }) {
  const active = useActiveWorkspace();
  const [brokenUrl, setBrokenUrl] = useState<string | null>(null);
  const url = active?.logoUrl ?? null;

  if (!url || url === brokenUrl) return <Wordmark className={className} />;

  return (
    <img
      src={url}
      alt={active?.name ?? ''}
      className={cn('block h-8 max-w-[168px] object-contain object-left', className)}
      onError={() => {
        setBrokenUrl(url);
      }}
    />
  );
}
